<template>
  <!-- IE 浏览器 不再支持 提示 -->
  <w-dialog :show="show" :boxStyle="{width: '494px'}" class="confirm-wall">
    <div class="confirm-content">
      <p class="confirm-title f-cb">
        <i class="r2-icon-alert_error float_left"></i>
        <span class="float_left">浏览器兼容提示</span>
      </p>
      <i class="r2-icon-nav_close" @click="close"></i>
      <p class="main-tips">亲爱的用户，自 2020 年 9 月起，造价云不再支持 IE 浏览器的兼容，建议您使用以下浏览器访问造价云。</p>
      <div class="browser-list flex">
        <div class="flex-1">
          <p>
            <img :src="browserChrome" width="0">
          </p>
          <p class="browser-name">Chrome</p>
        </div>
        <div class="flex-1">
          <p>
            <img :src="browser360" width="0">
          </p>
          <p class="browser-name">360</p>
        </div>
      </div>
    </div>
  </w-dialog>
</template>
<style lang="less" type="text/less" scoped>
  .confirm-content{
    padding: 12px 16px;
    .confirm-title{
      height: 32px;
      font-size:20px;
      font-weight: 500;
      line-height: 32px;
      color:rgba(33,37,48,1);
      .r2-icon-alert_error{
        font-size: 32px;
        color: #FE9B07;
      }
      span{
        margin-left: 8px;
        line-height: 30px;
      }
    }
    .r2-icon-nav_close{
      color: rgba(33,37,48,0.35);
      font-size: 22px;
      position: absolute;
      right: -4px;
      top: -6px;
      cursor: pointer;
    }
    .main-tips{
      font-size: 16px;
      font-weight: 400;
      color: rgba(33,37,48,0.8);
      line-height: 28px;
      margin-top: 20px;
    }
    .browser-list{
      margin-top: 48px;
      text-align: center;
      padding: 0 47px;
      img{
        width: 61px;
        height: 61px;
      }
      .browser-name{
        font-size:14px;
        font-weight:500;
        color:rgba(33,37,48,0.8);
        line-height:22px;
        margin-top: 15px;
      }
    }
  }
</style>
<script>
import {isIE} from '@/assets/utils'
const browserChrome = require('assets/images/indexpage/index/browser-chrome.png')
const browser360 = require('assets/images/indexpage/index/browser-360.png')
export default {
  name: 'DialogBrowserRecommend',
  data () {
    return {
      browserChrome,
      browser360,
      show: false,
      isIE: isIE()
    }
  },
  mounted () {
    if (this.isIE) {
      this.show = true
    }
  },
  methods: {
    // 1. 关闭弹窗
    close () {
      this.show = false
    }
  }
}
</script>
